import { Link } from 'expo-router'
import { TouchableOpacity, View } from 'react-native'
import { mesaColorNames } from '@/src/common/theme'
import { useLoggedInQuery } from '@/src/common/gql/MesaGql'
import { useRefetchQueryOnFocus } from '@/src/common/hooks/useRefetchQueryOnFocus'
import { GET_UNREAD_NOTIFICATIONS } from '@/src/common/components/Profile/NotificationsEntryPoint'
import { styled } from 'tamagui'
import { Notifications } from '@/src/assets/icons/Notifications'
import { DesignSystem } from '@/src/design-system'

const StyledNotifications = styled(Notifications, {
  color: '$textDark',
  height: 32,
  width: 32,
})

export function NotificationsButton() {
  const { data: unreadNotifications, refetch: refetchUnreadNotifications } = useRefetchQueryOnFocus(
    useLoggedInQuery(GET_UNREAD_NOTIFICATIONS, {
      fetchPolicy: 'cache-and-network',
      // every hour
      pollInterval: 60 * 60 * 1000,
    }),
  )

  DesignSystem.ScreenWideReload.useReloadListener(async () => {
    await refetchUnreadNotifications()
  })

  return (
    <Link href="/main/notification-center" push asChild>
      <TouchableOpacity
        style={{ alignItems: 'flex-end' }}
        testID="profile-notifications"
        hitSlop={10}
        activeOpacity={0.5}
      >
        <StyledNotifications />
        {unreadNotifications?.getUserNotifications.notifications.length ? (
          <View
            style={{
              position: 'absolute',
              top: -4,
              left: -4,
              zIndex: 1,
              alignItems: 'center',
              flexDirection: 'row',
              justifyContent: 'center',
              backgroundColor: mesaColorNames['Mesa Third #E78A43'],
              borderRadius: 12,
              height: 8,
              width: 8,
            }}
          />
        ) : null}
      </TouchableOpacity>
    </Link>
  )
}
